enum EntityPriority {
  NONE,
  PRIMARY,
  SECONDARY,
}

export default EntityPriority;
